<template>
  <div id="simpleQuoteApp">
    <!--
    <div class="bgimage">
      <div class="navhold">
        <div class="col s10 l10">
          <div id="topLogo">
            <div id="logo"></div>
            <h3>Get fast, cheap car insurance quotes with one simple form. Cheapest rates from only $19/mo!</h3>
          </div>
        </div>
      </div>
      <div class="section no-pad-bot" id="index-banner">
        <div class="row nopad">
          <div class="dis-text2 right">
            <a href="http://safeunsubscribing.com/o-gpzs-g42-1980d02939efc0392ca0ee37a0e3bdb0" target="_blank">Unsubscribe Here</a>
          </div>
        </div>
        <div class="container">
          <h1 class="header center">Compare Multiple Auto Insurance Quotes in Minutes</h1>
          <div class="row center">
            <h5 class="header col s12">Rates as low as <span class="yellowtexthead">$1 a day</span></h5>
          </div>
          <div class="row center">
            <div class="btnhold">
              <form
                action="https://w4.pingpost.com/53d12a2a7ff5cf4eafb5e0b14dcee3c2/post?zip=&sub1=&sub2=&sub3=&sub4=&redirect=1"
                id="my_form"
                autocomplete="off"
                method="POST"
              >
                <div class="row">
                  <div class="input-field col s10 m6 l6">
                    <input
                      placeholder="Enter Zip Code"
                      id="zip"
                      type="text"
                      oninput="validate()"
                      maxlength="5"
                      class="validate"
                      name="zipcode"
                      required
                    >
                  </div>
                  <div style="padding-right: 0;" class="col s2 m6 l6">
                    <button data-target="modal1" class="btngo modal-trigger" id="my_button" disabled="disabled">
                      <span class="cta_d">See My Rates</span>
                      <span class="cta_m">GO</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div class="lockhold"><div class="lock"><img src="./assets/lock.png" width="15px"></div>
              We use 256 bit SSL technology to encrypt your data
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lenderbar">
      <div class="lenderbartext">Get down to the nuts and bolts of <span class="yellowtext">top companies</span> by comparing them head-to-head.</div>
      <div class="lenderlogos"><img src="./assets/client_logos_White1.png" class="responsive-img"></div>
    </div>
    <div class="container">
      <div class="section">
        <div class="row">
          <h2>Find Auto Insurance In 4 Easy Steps</h2>
          <div class="col s12 m12 l12"> <div class="lineimage"><img src="./assets/line.png" class="responsive-img"></div></div>
        </div>
        <div class="row">
          <div class="col s12 m6 l3">
            <div class="icon-block">
              <div class="center iconimage"><img src="./assets/icon1.jpg" class="responsive-img"></div>
              <div class="beniNumber">1</div>
              <p class="beniText">Start by filling
                out a quick and
                simple form</p>
            </div>
          </div>

          <div class="col s12 m6 l3">
            <div class="icon-block">
              <div class="center iconimage"><img src="./assets/icon2.jpg" class="responsive-img"></div>
              <div class="beniNumber">2</div>
              <p class="beniText">Our insurance
                partners compete
                for your business</p>
            </div>
          </div>

          <div class="col s12 m6 l3">
            <div class="icon-block">
              <div class="center iconimage"><img src="./assets/icon3.jpg" class="responsive-img"></div>
              <div class="beniNumber">3</div>
              <p class="beniText">Compare their
                personalized
                custom quotes</p>
            </div>
          </div>
          <div class="col s12 m6 l3">
            <div class="icon-block">
              <div class="center iconimage"><img src="./assets/icon4.jpg" class="responsive-img"></div>
              <div class="beniNumber">4</div>
              <p class="beniText">Choose the
                best policy option
                that’s right for you</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sect1">
      <div class="container">
        <div class="row">
          <div class="col s12 m6 l6">
            <div class="imagehold"><img src="./assets/check.png" class="responsive-img"></div>
          </div>
          <div class="col s12 m6 l6">
            <h2 class="alileft">Don’t overpay for car insurance.<br>
              Don’t skimp on coverage.</h2>
            <p>Car insurance comes with a lot of moving parts.
              We give you the tools, insight, and know-how to find
              the right policy at the right price.</p>
            <div class="toplists btngreen">Get Started</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgimage2">
      <div class="container">
        <div class="row">
          <div class="col s12 m12 l12">
            <h2 class="whitetext">Guard what matters most
              while saving money in the process.</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="sect2">
      <div class="container">
        <div class="row">
          <div class="col s12 m6 l6">
            <h2 class="alileft">Compare Insurance<br>
              Companies Head-to-Head</h2>
            <p>Every insurance carrier is different. We cover the pros
              and cons, plan specifics, and ratings for 30 companies.
              Get down to the nuts and bolts of top companies by
              comparing them directly.</p>
            <div class="toplists btngreen">Get Started</div>
          </div>
          <div class="col s12 m6 l6">
            <div class="imagehold2"><img src="./assets/scale1.png" class="responsive-img"></div>
          </div>
        </div>
      </div>
    </div>
    <footer class="page-footer">
      <div class="container">
        <div class="row">
          <div class="row">
            <div class="col s12 l12"><div class="logoholdfoot2"><img src="./assets/logog.png" class="responsive-img"></div></div>
          </div>
          <div class="col l12 s12">
            <div class="dis-text"></div>
            <div class="dis-text center">© 2020 Livewire Insurance. All rights reserved.</div>
            <div class="dis-text center">
              <a href="http://safeunsubscribing.com/o-gpzs-g42-1980d02939efc0392ca0ee37a0e3bdb0" target="_blank">
                Unsubscribe Here
              </a>
            </div>
            <div class="dis-text center">
              <a href="https://quotes.livewireinsurance.com/home/?openaction=qw&subaction=contact" target="_blank">Contact Us</a> |
              <a href="privacy.php" target="_blank">Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
    -->
    <!--<img alt="Protect logo" src="././assets/logo.png">
        <div id="nav">
          <router-link to="/">Home</router-link> |
          <router-link to="/page">Page</router-link>
    </div>-->
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/page">Page</router-link>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  created() {
    // favicon
    const { faviconPath, faviconFileType } = this.$store.state.globalMetaData;

    if (typeof faviconPath !== 'undefined' && typeof faviconFileType !== 'undefined') {
      const faviconTag = document.createElement('link');
      faviconTag.setAttribute('rel', 'icon');
      faviconTag.setAttribute('href', faviconPath);
      faviconTag.setAttribute('type', faviconFileType);
      document.head.appendChild(faviconTag);
    }
  },
};
</script>

<style lang="scss">
@import './scss/materialize';
@import './scss/style2';
</style>
